<template>
  <v-container class="pa-0 ma-0 d-flex flex-column gap-12">
    <!-- header -->
    <v-container class="pa-0 ma-0">
      <Header
        :coverURL="cover"
        :iconURL="icon"
        :name="headerTitle"
        :desc="headerSubTitle"
      />
    </v-container>
    <v-container class="pa-0 ma-0">
      <v-container v-if="loading" class="scroll-container pa-0 ma-0">
        <v-skeleton-loader
          v-if="loading"
          v-for="n in 6"
          :key="n"
          class="category-img"
          type="image"
        />
      </v-container>

      <v-container class="ma-0 pt-3 px-3 category-scroll" id="navbar">
        <v-container class="pa-0 ma-0 scroll-container">
          <v-text-field
            v-model="search"
            :label="$t('Search in Products')"
            height="38"
            outlined
            class="rtl-text ma-0 pa-0"
            hide-details="auto"
            clearable
            prepend-inner-icon="mdi-magnify"
          />
        </v-container>
      </v-container>

      <v-container class="ma-0 pt-3 px-3 category-scroll" id="navbar">
        <v-container class="pa-0 ma-0 scroll-container">
          <v-container
            v-if="!loading"
            ref="CategoryId"
            v-for="(category, i) in products"
            :key="i"
            class="ma-0 pa-0 category-card"
            @click="scrollToCategory(category.categoryId)"
          >
            <v-img :src="category.image" alt="" class="category-img" />
            <v-card-text class="pa-0 ma-0 my-2 category-title">{{
              category.name
            }}</v-card-text>
          </v-container>
        </v-container>
      </v-container>
      <v-container class="ma-0 food-list">
        <v-skeleton-loader
          v-if="loading"
          v-for="n in 8"
          :key="n"
          class="pa-3 mb-3 food-card-skeleton"
          type="table-heading"
        />

        <!-- vertical list of product scrolling -->
        <v-container
          v-if="!loading"
          class="ma-0"
          v-for="(category, i) in filteredProducts"
          :key="i"
          :id="'category-' + category.categoryId"
          :style="{
            'padding-bottom':
              i == filteredProducts.length - 1 || i == filteredProducts.length - 1 && filteredProducts[filteredProducts.length - 1]?.items?.length < 2
                ? '200px !important'
                : '0',
          }"
        >
          <!-- category title -->
          <v-card-text class="pa-0 ma-0 pb-4">{{ category.name }}</v-card-text>
          <!-- product image and details  -->
          <v-container
            v-for="(item, j) in category.items"
            :key="j"
            class="ma-0 px-3 pa-2 food-card mb-3"
          >
            <img
              :src="item.image"
              alt="image"
              class="food-image"
              @click="openDetails(item)"
            />

            <v-container class="pa-0 ma-0 food-info">
              <v-card-text
                class="pa-0 ma-0 food-title px-3 py-2"
                @click="openDetails(item)"
              >
                {{ truncateText(item.name, 22) }}
              </v-card-text>
              <v-card-text class="pa-0 ma-0 food-desc px-3" @click="openDetails(item)">{{
                item.desc
              }}</v-card-text>

              <v-container
                class="pa-0 ma-0 d-flex justify-space-between align-center price-action-row"
              >
                <!-- price and currency  -->
                <v-container class="pa-0 ma-0 d-flex flex-column gap-1 py-2">
                  <v-card-text class="pa-0 ma-0 food-price px-2"
                    >{{ item.price }} {{ $store.state.currency.name }}</v-card-text
                  >
                </v-container>
                <!-- add product btn  -->
                <v-sheet class="pa-0 ma-0 action-buttons">
                  <v-btn
                    outlined
                    color="#007AFF"
                    class="add-btn"
                    height="20"
                    width="20"
                    v-if="(cartItems.find((p) => p.id === item.id)?.count || 0) <= 0"
                    @click="$emit('add', item)"
                  >
                    {{ $t("add") }}

                    <v-icon size="16" class="mr-2">mdi-plus</v-icon>
                  </v-btn>

                  <v-container v-else class="pa-0 ma-0 counter">
                    <v-btn
                      outlined
                      color="#007AFF"
                      class="counter-btn"
                      height="18"
                      width="18"
                      style="min-width: auto"
                      @click="$emit('add', item)"
                    >
                      <v-icon size="15">mdi-plus</v-icon>
                    </v-btn>
                    <div class="count">
                      {{ cartItems.find((p) => p.id === item.id)?.count || 0 }}
                    </div>

                    <v-btn
                      outlined
                      color="#007AFF"
                      class="counter-btn"
                      height="18"
                      width="18"
                      style="min-width: auto"
                      @click="$emit('remove', item)"
                      :disabled="
                        (cartItems.find((p) => p.id === item.id)?.count || 0) <= 0
                      "
                    >
                      <v-icon size="15">mdi-minus</v-icon>
                    </v-btn>
                  </v-container>
                </v-sheet>
              </v-container>
            </v-container>
          </v-container>
        </v-container>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import Mixin from "@/Mixins/mixin";
import Header from "./Header.vue";

export default {
  name: "ProductScrollVertical",
  mixins: [Mixin],
  components: {
    Header,
  },
  props: {
    cartItems: { type: Array, required: true },
    shopHash: {
      type: String,
      required: true,
    },
    shopuid: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      products: [],
      categories: [],
      category: "",
      productName: "",
      search: "",
      desc: "",
      cover: "",
      icon: "",
      headerTitle: "",
      headerSubTitle: "",
      icon: "",
      loading: false,
    };
  },
  watch: {},
  computed: {
    filteredProducts() {
      const query = (this.search || "").trim().toLowerCase();
      if (!query) return this.products;
      return this.products
        .map((category) => {
          const filteredItems = category.items.filter((item) =>
            item.name.toLowerCase().includes(query)
          );
          return { ...category, items: filteredItems };
        })
        .filter((category) => category.items.length > 0);
    },
  },
  mounted() {
    if (this.shopHash && this.shopuid) {
      this.getProductList(this.shopHash, this.shopuid);
    }
  },
  methods: {
    getCount(id) {
      const found = this.cartItems.find((p) => p.id === id);
      return found ? found.count : 0;
    },
    getProductList(shopHash, shopUid) {
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "menu/setting/get-category", {
          params: {
            slug: shopHash,
            cuid: shopUid,
          },
        })
        .then((response) => {
          const paymentDetails = {
            invoiceType: response.data.invoice_type || null,
            offlinePayment: response.data.offline_payment || null,
            onlinePayment: response.data.online_payment || null,
            gateway: response.data.gateway || null,
            entrepotId: response.data.entrepot_id || null,
            content: response.data.content || null,
          };
          this.$emit("paymentDetails", paymentDetails);
          const headerData = {
            iconURL: response.data.icon?.link,
            name: response.data.name,
            desc: response.data.content,
          };
          this.$emit("headerData", headerData);
          this.cover = response.data.cover?.link;
          this.icon = response.data.icon?.link;
          this.headerTitle = response.data?.name;
          this.headerSubTitle = response.data?.content;
          const res = response.data.product_categories || [];
          this.products = res.map((category) => ({
            categoryId: category.id,
            name: category.name || this.$t("no name"),
            image: category.avatar?.link
              ? category.avatar.link
              : require("@/assets/shopping/default.png"),
            items: (category.products || []).map((p) => ({
              id: p.id,
              name: p.name || "",
              desc: p.content || p.content || this.$t("no desc"),
              image: p.avatar?.link
                ? p.avatar?.link
                : require("@/assets/shopping/default.png"),
              price: this.$numberFormat(p.price) || 0,
            })),
          }));
        })
        .catch((err) => {
          app.loading = false;
          app.$router.push("/403");
        })
        .finally(() => {
          app.loading = false;
        });
    },
    openDetails(item) {
      this.$emit("selectProduct", item);
      this.$emit("open", true);
    },
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.slice(0, maxLength) + "…" : text;
    },
    scrollToCategory(val) {
      const element = document.getElementById("category-" + val);
      if (element) {
        const navbarHeight = 150;
        const y = element.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
        window.scrollTo({
          top: y,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-label {
  top: 10px !important;
}
::v-deep .v-label.v-label--active {
  top: 18px !important;
}
#navbar {
  position: sticky;
  top: 0px;
  z-index: 99;
  background-color: #ffffff;
  opacity: 1;
  opacity: 1px;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  display: flex;
  justify-content: flex-end;
}
.scroll-container {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  gap: 12px;
}

.category-card {
  flex: 0 0 auto;
  text-align: center;
  border-radius: 16px;
  background-color: #ffffff;
  width: auto;
}

.category-img {
  width: 72px;
  height: 72px;
  border-radius: 12px;
  border: 1px solid #d9d9d9;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.category-title {
  margin-top: 6px;
  font-weight: 500;
  font-size: 12px !important;
  color: #000;
}
.food-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.food-card {
  display: flex;
  align-items: center;
  border-radius: 4px;
  background-color: transparent;
  border: solid 1px #d9d9d9;
}
.food-card-skeleton {
  border-radius: 4px;
  background-color: transparent;
  border: solid 1px #d9d9d9;
}
.food-image {
  width: 84px !important;
  height: 84px !important;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  object-fit: cover;
  display: block !important;
  background-color: transparent !important;
  cursor: pointer;
}
.food-info {
  flex: 1;
  text-align: right;
}
.food-title {
  font-weight: 600;
  margin: 0;
  cursor: pointer;
}
.food-desc {
  font-size: 14px;
  color: #666;
  margin: 4px 0;
  cursor: pointer;
}
.food-price {
  font-size: 15px;
  font-weight: 500;
  color: #333;
}
.action-buttons {
  margin-top: 8px;
}
.counter {
  display: flex;
  align-items: center;
  gap: 8px;
}
.count {
  font-size: 12px;
  font-weight: 500;
  color: #333;
  background-color: #d9d9d9;
  padding: 4px 14px;
  border-radius: 6px;
}
</style>
